import { useDispatch, useSelector } from 'react-redux';
import { apiResponseModalSliceDispatch, selectFileSliceDispatch } from "../../Constants/ReduxConstants";
import UploadFileService from "../../Services/UploadFileService";
import SelectFileModal from "../SelectFileModal/SelectFileModal";

const SelectFile = () => {
    const isLoading = useSelector((state: any) => state.refreshLoadedFile.isLoading);
    const fileLength = useSelector((state: any) => state.pickAFile.fileLength);

    const dispatch = useDispatch()

    async function SelectFile() {
        dispatch({ type: selectFileSliceDispatch.setIsDataModel, payload: true })

        let isApiCallSuccessful: boolean = false;

        //Get the url for downloading the file.
        let treeUrl: string = "";

        await UploadFileService.getUploadFileRepoURL()
            .then(response => {
                if (response.status == 200) {
                    isApiCallSuccessful = true;

                    treeUrl = response.data._links.tree.href
                }
                else {
                    isApiCallSuccessful = false;

                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: response.data })
                }
            })
            .catch((e) => {
                isApiCallSuccessful = false;

                treeUrl = "";

                dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: e.message })
                dispatch({ type: selectFileSliceDispatch.setIsDataModel, payload: false })
            });;

        //Get the json file from Azure.
        if (isApiCallSuccessful) {
            await UploadFileService.getUploadFileRepoEntities(treeUrl)
                .then(response => {
                    if (response.status == 200) {

                        dispatch({ type: selectFileSliceDispatch.setSelectedFilesList, payload: response.data.treeEntries.map(x => x.relativePath) })

                        dispatch({ type: selectFileSliceDispatch.setOpen, payload: true })
                    }
                    else {
                        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                        dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: response.data })
                    }
                })
                .catch((e) => {
                    dispatch({ type: selectFileSliceDispatch.setOpen, payload: false })

                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: e.message })
                    dispatch({ type: selectFileSliceDispatch.setIsDataModel, payload: false })
                });;
        }
    }

    //Need to leave empty element here to avoid jsx needs parent elemnt error.
    //Any other valid element will throw off the formatting in App.js.
    const select = (
        <>
            <button disabled={fileLength != null || isLoading} onClick={SelectFile} title="Select File From Azure">Select File From Azure</button>
            <SelectFileModal />
        </>
    )

    return select;
}

export default SelectFile;